import { Injectable } from '@angular/core';
import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { AppConfig } from '../app.config';
import { DIMBO_CONSTANT } from '../utils/constant';
import { Observable, throwError } from 'rxjs';
import { Services } from '../model/services';
import {catchError, tap, map} from 'rxjs/operators';
import { HttpService } from './http.service';
import { CacheService } from './cache.service';

@Injectable({
  providedIn: 'root'
})
export class ServiceHistoryService {
  domain: string;
  
  constructor(private http: HttpClient , private apiconfig :AppConfig,
    private httpservice:HttpService ,private cacheService: CacheService) { 
      var apipath='';
      if(this.apiconfig.mpsaFlag==='N'){
        apipath = location.protocol + '//' + this.apiconfig.apiUrl;
      }

    this.domain = apipath+this.apiconfig.apiPath;
    }


  getServiceHistory():Observable <Services [] > {
   // let domain = this.apiconfig.apiPath;
    let vin =this.cacheService.getItem(DIMBO_CONSTANT.CACHE_JWT_VIN);
    //console.log("SH URL: "+vin);
    let finalURL=this.domain+'/contracts/'+vin +'/services';
    return this.httpservice.getWithObserve(finalURL);
  }
  

  getSingleServiceHistory(serviceId: string):Observable <Services> {
  //  let domain = this.apiconfig.apiPath;
    let vin =this.cacheService.getItem(DIMBO_CONSTANT.CACHE_JWT_VIN);
    let finalURL=this.domain+'/'+vin+'/services?serviceId='+serviceId;
    return this.httpservice.getWithObserve(finalURL);
  }

  putServiceHistory(serviceId: any ,param :any) {
    //let domain = this.apiconfig.apiPath;
    let finalURL=this.domain+'/services/'+serviceId;
    return this.httpservice.postWithObservSH(finalURL, param);
  }

  putServiceHistoryMileage( serviceId: any , mileagevalue : any , mileageunit : any ,param :any) {
    let vin= this.cacheService.getItem(DIMBO_CONSTANT.CACHE_JWT_VIN);
   // let domain = this.apiconfig.apiPath;
    let finalURL=this.domain+'/services/'+vin+'/'+serviceId+'/mileage?mileage='+mileagevalue+'&mileageUnit='+mileageunit;
    return this.httpservice.postWithObserve(finalURL, param);
  }
}
